/**
 * @typedef {import('./Props').default} Props
 */

import { translate } from '../../Internationalization';
import { withHomeownerService } from '../../../service-container';
import { withProperty } from 'App/Homeowner/PropertyProvider';
import AllConnectWidget from './AllConnectWidget';
import MoveConciergePortal from './MoveConciergePortal';
import React from 'react';

/** @extends {React.Component<Props>} */
export class Utilities extends React.Component {
	/**
	 * @returns {JSX.Element}
	 */
	render() {
		return (
			<article className="mx-auto max-w-app">
				<header className="mt-10 mb-6">
					<h1 className="hl-ms-6 mb-3">
						{translate('homeowner.pages.utilities.title')}
					</h1>
					<p>
						{translate(
							'homeowner.pages.properties.view.utilities.subtext'
						)}
					</p>
				</header>

				<section className="mb-10">
					<MoveConciergePortal withTitle={false} />
				</section>

				<section className="rich-text mb-4">
					<h2>
						{translate(
							'homeowner.pages.properties.view.utilities.allconnect_title'
						)}
					</h2>

					<p>{translate('homeowner.pages.utilities.lead')}</p>
				</section>

				<AllConnectWidget
					address={this.props.property.selectedProperty?.address}
				/>
			</article>
		);
	}
}

export default withHomeownerService(withProperty(Utilities));
